import { queryOptions } from '@tanstack/react-query';

import type {
  BookingGroupSessionDetail,
  BookingGroupSessionQueryParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingGroupSessionKeys = {
  all: () => ['bookingGroupSessions'] as const,
  detail: (props: BookingGroupSessionQueryParams) =>
    [...bookingGroupSessionKeys.all(), 'detail', props.url, props.id] as const,
};

export const bookingGroupSessionQueries = {
  detail: (props: BookingGroupSessionQueryParams) =>
    queryOptions({
      queryKey: bookingGroupSessionKeys.detail(props),
      queryFn: () =>
        HttpClient.request<BookingGroupSessionDetail>({
          method: 'GET',
          url: `${props.url}/${props.id}`,
        }),
      enabled: !!props.url && !!props.id,
      refetchOnWindowFocus: true,
    }),
};
